import type { RaasInitConfig } from "./types";

/** Reads `data-tenant-id`, `data-tenant-key`, `data-allocated-channels` (JSON array), optional `data-verbose` from `document.currentScript`. */
export const parseInitFromCurrentScript = (): RaasInitConfig | null => {
  if (typeof document === "undefined") return null;

  const el = document.currentScript as HTMLScriptElement | null;
  const { tenantId, tenantKey, allocatedChannels: raw, verbose } =
    el?.dataset ?? {};

  if (!tenantId?.trim() || !tenantKey?.trim() || !raw?.trim()) return null;

  let allocatedChannels: unknown;
  try {
    allocatedChannels = JSON.parse(raw);
  } catch {
    return null;
  }
  if (!Array.isArray(allocatedChannels)) return null;

  return {
    tenantId: tenantId.trim(),
    tenantKey: tenantKey.trim(),
    allocatedChannels: allocatedChannels as string[],
    verbose: /^(1|true|yes)$/i.test(verbose ?? ""),
  };
};
